module.exports = __webpack_public_path__ + "img/ssig_argensig.dcd8dea2.png";